export default "/institutions/us-bank.svg";